import script from "./SuggestList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestList.vue?vue&type=script&setup=true&lang=ts"

import "./SuggestList.vue?vue&type=style&index=0&id=cc1ac1e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc1ac1e8"]])

export default __exports__